import { render, staticRenderFns } from "./VerifyPoints.vue?vue&type=template&id=487d0090"
import script from "./VerifyPoints.vue?vue&type=script&lang=js"
export * from "./VerifyPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('487d0090')) {
      api.createRecord('487d0090', component.options)
    } else {
      api.reload('487d0090', component.options)
    }
    module.hot.accept("./VerifyPoints.vue?vue&type=template&id=487d0090", function () {
      api.rerender('487d0090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/verifition/Verify/VerifyPoints.vue"
export default component.exports